import { createContext } from 'react';
import {
  Pim,
  Observation,
  ClearScripts,
  Workflow,
  Scheduler,
  Reporting,
  ServiceConfig,
} from '@mummssoftware/utils';
import { LoggerType } from '@mummssoftware/logger';
import { DEFAULT_LOCALE } from './i18n';
import { Config, DashboardType } from './containers/Context/types';

export type Context = {
  keycloak: Keycloak.KeycloakInstance;
  currentUser: mumms.User;
  agency: string;
  locale: keyof mumms.translations;
  patient?: mumms.patient;
  pim: Pim;
  observation: Observation;
  clearscripts: ClearScripts;
  workflow: Workflow;
  scheduler: Scheduler;
  reporting: Reporting;
  serviceConfig: ServiceConfig;
  /** Config-service user id (Keycloak email / preferred_username). */
  configUserId?: string;
  /** Marks unsaved patient dashboard layout edits; blocks background GET refresh. */
  setWidgetConfigLayoutDirty?: (dirty: boolean) => void;
  /**
   * After layout PUT success — see {@link Dashboard#onDashboardLayoutSaved}
   * in `apps/dashboard/src/index.tsx`.
   */
  onDashboardLayoutSaved?: (
    layout: mumms.WidgetConfig[],
    dashboard: mumms.WidgetConfigDashboard,
  ) => void;
  config: Config | null;
  isMummsAdmin?: boolean;
  isImpersonating?: boolean;
  patientError?: mumms.PatientError;
  onDashboardThemeChange: (arg: string) => void;
  dashboardType: DashboardType;
  siteId?: string | null;
  idgMeeting: any;
  // add VisitAttribute[] property to context
  visitAttributes: mumms.VisitAttribute[];
  logger?: LoggerType;
};

const initContext = {
  locale: DEFAULT_LOCALE,
};

export const Context = createContext<Context>(initContext as Context);
export const ContextProvider = Context.Provider;
export const ContextConsumer = Context.Consumer;
